import React from 'react';

const IndexNumber = ({ num }) => (
  <div className="mr-4 md:mr-12 lg:mr-20">
    <span className="text-black-500">0{num + 1}</span>
  </div>
);

export default IndexNumber;
